var ClientUsageReportParams = /** @class */ (function () {
    function ClientUsageReportParams(fromDate, toDate, selectedTaxSoftware, groupBy, deliveryMode, companyId) {
        this.fromDate = fromDate;
        this.toDate = toDate;
        this.selectedTaxSoftware = selectedTaxSoftware;
        this.groupBy = groupBy,
            this.deliveryMode = deliveryMode,
            this.companyId = companyId;
    }
    return ClientUsageReportParams;
}());
export { ClientUsageReportParams };
